const FILE_ICON_BY_EXTENSION = {
  aep: 'fileAep',
  ai: 'fileAi',
  avi: 'fileAvi',
  blend: 'fileBlend',
  c4d: 'fileC4d',
  cdr: 'fileCdr',
  css: 'fileCss',
  csv: 'fileCsv',
  dmg: 'fileDmg',
  doc: 'fileDoc',
  docx: 'fileDocx',
  exe: 'fileExe',
  fig: 'fileFig',
  gif: 'fileGif',
  html: 'fileHtml',
  ico: 'fileIco',
  java: 'fileJava',
  jpeg: 'fileJpeg',
  jpg: 'fileJpg',
  js: 'fileJs',
  json: 'fileJson',
  mov: 'fileMov',
  mp3: 'fileMp3',
  mp4: 'fileMp4',
  mpg: 'fileMpg',
  pdf: 'filePdf',
  png: 'filePng',
  ppt: 'filePpt',
  psd: 'filePsd',
  rar: 'fileRar',
  skt: 'fileSkt',
  svg: 'fileSvg',
  tiff: 'fileTiff',
  txt: 'fileTxt',
  wav: 'fileWav',
  webp: 'fileWebp',
  xls: 'fileXls',
  xlsx: 'fileXlsx',
  zip: 'fileZip',
} as const

export const DEFAULT_FILE_ICON_NAME = 'fileDefault'

export type FileIconName =
  | typeof DEFAULT_FILE_ICON_NAME
  | typeof FILE_ICON_BY_EXTENSION[keyof typeof FILE_ICON_BY_EXTENSION]

export const getFileIconName = (name: string): FileIconName => {
  const extension = name.split('.').pop()?.toLowerCase()
  if (!extension || !name.includes('.')) return DEFAULT_FILE_ICON_NAME

  return FILE_ICON_BY_EXTENSION[extension as keyof typeof FILE_ICON_BY_EXTENSION]
    ?? DEFAULT_FILE_ICON_NAME
}
